<template>
	<v-snackbar v-model="showChatNotification" color="success" :timeout="-1">
		{{ message }}
		<template v-slot:action="{ attrs }">
			<v-btn color="white" text v-bind="attrs" @click="handleClose()"> Close </v-btn>
		</template>
	</v-snackbar>
</template>

<script>
import { maybePluralize } from '@/utils/helpers'

export default {
	name: 'ChatNotification',
	props: {
		notifications: {
			type: Array,
			default: () => [],
		},
		showChatNotification: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		handleClose() {
			this.$emit('closeChatNotification')
		},
	},
	computed: {
		message() {
			return `You have ${maybePluralize(this.notifications.length, 'unread message')}`
		},
	},
	data() {
		return {
			snackbar: false,
		}
	},
}
</script>

<style scoped></style>
